import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

export const schema: ComponentSchema = {
  type: "offer-banner",
  label: "Offer Banner",
  description: "A mint banner with a headline, a line and a button, and an optional picture on the right.",
  supportedPages: ["home", "shop", "category"],
  variants: [
    {
      id: "v1",
      label: "Mint banner",
      fields: [
        { key: "image", label: "Small picture before the text (optional)", type: "image", help: "Payment artwork or a logo, shown at most 32px tall." },
        { key: "title", label: "Title", type: "string", default: "Special Offer" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Get up to 50% off on selected items" },
        { key: "ctaText", label: "Button Text", type: "string", default: "Shop Now" },
        { key: "ctaLink", label: "Button Link", type: "string", default: "/shop" },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
